import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import CounselingRoomRepository from '@/repositories/counselingRoomRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useCounselingRoomGuidanceStore = defineStore({
    id: 'counselingRoomGuidance',
    state: () => ({
        roomName: '',
        roomAddr: '',
        roomNote: '',
        roomMapImg: '',
        imgFileExt: null,
    }),
    getters: {},
    actions: {
        reset() {
            this.roomName = '';
            this.roomAddr = '';
            this.roomNote = '';
            this.roomMapImg = '';
            this.imgFileExt = null;
        },
        /**
         * カウンセリングルーム案内取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getCounselingRoomGuidanceAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const counselingRoomRepository = new CounselingRoomRepository();
            try {
                const response = await counselingRoomRepository.getCounselingRoomGuidanceApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                // ユーザー情報をstoreに格納
                this.roomName = response.data.RoomNm;
                this.roomAddr = response.data.RoomAddr;
                this.roomNote = response.data.RoomNote;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * カウンセリングルーム案内地図画像取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getCounselingRoomGuidanceMapImageAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const counselingRoomRepository = new CounselingRoomRepository();
            try {
                const response = await counselingRoomRepository.getCounselingRoomGuidanceMapImageApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                // ユーザー情報をstoreに格納
                this.imgFileExt = response.data.ImgFileExt;
                this.roomMapImg = response.data.RoomMapImg;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
